import { render, staticRenderFns } from "./welcomeAnswer.vue?vue&type=template&id=536d4d17"
import script from "./welcomeAnswer.vue?vue&type=script&lang=js"
export * from "./welcomeAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports